import constant from "../main.constants";

// Akşit modülü, fraud tarafındaki sayfaları AML tarafında kendi menüsüyle açar.
// Yetkiler fraud tarafıyla birebir aynıdır.
const aksitSystemSettingsRoutes = [
    {
        path: "/aksit/management/response-types",
        name: "AksitResponseTypes",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/ResponseType.vue"),
        },
        meta: {
            icon: "mdi-keyboard-return",
            localize: "fraud.menu.responseTypes"
        },
        perm: constant.PERMISSIONS.systemSettings.responseType
    },
    {
        path: "/aksit/management/ruleset-types",
        name: "AksitRuleSetTypes",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSetType.vue"),
        },
        meta: {
            icon: "mdi-text-search-variant",
            localize: "fraud.menu.ruleSetTypes"
        },
        perm: constant.PERMISSIONS.systemSettings.ruleSetType
    },
    {
        path: "/aksit/serviceresponses",
        name: "AksitServiceResponse",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudServiceResponses.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.serviceResponses",
            isEntitySelectionEnabled: true
        },
        perm: constant.PERMISSIONS.systemSettings.serviceResponse
    },
    {
        path: "/aksit/management/service-response-transitions",
        name: "AksitServiceReponseTransition",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudServiceResponseTransition.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.serviceResponseTransitions",
            isEntitySelectionEnabled: true
        },
        perm: constant.PERMISSIONS.systemSettings.serviceResponseTransition
    },
    {
        path: "/aksit/management/incident-states",
        name: "AksitIncidentStates",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentStates.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.incidentStates",
        },
        perm: constant.PERMISSIONS.systemSettings.incidentState
    },
    {
        path: "/aksit/management/incident-state-transitions",
        name: "AksitIncidentStateTransitions",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentStateTransition.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.incidentStateTransitions"
        },
        perm: constant.PERMISSIONS.systemSettings.incidentStateTransition
    },
    {
        path: "/aksit/management/case-states",
        name: "AksitCaseStates",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseStates.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.caseStates",
        },
        perm: constant.PERMISSIONS.systemSettings.caseState
    },
    {
        path: "/aksit/management/case-state-transitions",
        name: "AksitCaseStateTransitions",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseStateTransition.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund",
            localize: "fraud.menu.caseStateTransitions"
        },
        perm: constant.PERMISSIONS.systemSettings.caseStateTransition
    },
];

const aksitRestActionRoutes = [
    {
        path: "/aksit/rest/actions",
        name: "AksitRestActions",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/RestServiceManagement.vue"),
        },
        meta: {
            icon: "mdi-api",
            localize: "fraud.menu.actions"
        },
        perm: constant.PERMISSIONS.actionManagement.actions
    },
    {
        path: "/aksit/rest/actionmappings",
        name: "AksitRestActionEntityMappings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/management/RestServiceEntityMappings.vue"),
        },
        meta: {
            icon: "mdi-api",
            localize: "fraud.menu.actionEntityMappings"
        },
        perm: constant.PERMISSIONS.actionManagement.actionEntityMapping
    },
];

export { aksitSystemSettingsRoutes, aksitRestActionRoutes };

const routes = [
    {
        path: "/aksit",
        name: "AksitHome",
        redirect: "/aksit/incident-management",
        meta: {}
    },
    {
        path: "/aksit/incident-management",
        name: "AksitIncidentManagements",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentManagement.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-calendar",
            localize: "fraud.incidents.title",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/aksit/case-management",
        name: "AksitCaseManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseGroup"),
        },
        meta: {
            icon: "mdi-briefcase-variant-outline",
            localize: "fraud.menu.caseGroupManagement"
        }
    },
    // Detay sayfalarının fraud tarafındaki karşılıkları (CaseDetails, IncidentDetails, EvidenceDetail).
    // Bu route'lar olmadan Akşit içindeki detay geçişleri fraud modülüne düşer.
    {
        path: "/aksit/case-management/details/:id",
        name: "AksitCaseDetails",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudCaseGroupDetail"),
        },
        meta: {
            icon: "mdi-account-details-outline",
            localize: "fraud.menu.caseGroupManagement"
        }
    },
    {
        path: "/aksit/incident/details/:id",
        name: "AksitIncidentDetails",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/FraudIncidentDetail"),
        },
        meta: {
            icon: "mdi-briefcase-variant-outline",
        }
    },
    {
        path: "/aksit/incident/:incidentid/rule/:ruleid/evidence",
        name: "AksitEvidenceDetail",
        component: () => import("../views/fraud/FraudEvidenceDetail"),
        meta: {
            localize: "fraud.menu.evidenceDetail",
            isFraudPage: true
        }
    },
    {
        path: "/aksit/rules/approved",
        name: "AksitApprovedRules",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/ApprovedRules.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-magnify",
            localize: "fraud.menu.rules.activeRules",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/aksit/rules/waitings",
        name: "AksitWaitingRules",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/WaitingRules.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-magnify",
            localize: "fraud.menu.rules.waitingRules",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/aksit/rules/history",
        name: "AksitRuleHistory",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleHistory.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-history",
            localize: "fraud.menu.rules.history",
            isEntitySelectionEnabled: true
        }
    },
    // Kural sayfaları göreli path ile yönlendirme yaptığı için (rule/..., rule-candidate/...)
    // fraud tarafındaki alt route'ların /aksit/rules altındaki karşılıkları da tanımlanmalıdır.
    {
        path: "/aksit/rules/rule-candidate/:ruleCandidateId/:entityName",
        name: "AksitRuleCandidate",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/aksit/rules/rule/:ruleId/:entityName",
        name: "AksitRule",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/aksit/rules/ruleQuery/:serviceEntityName",
        name: "AksitCreateRuleQuery",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/aksit/ruleQuery/:ruleId/:entityName",
        name: "AksitRuleQuery",
        component: () => import("../components/fraud/rule/RuleQueries.component.vue"),
        meta: {}
    },
    {
        path: "/aksit/rulesets",
        name: "AksitRuleSets",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSet.vue"),
            isServiceEntityRequired: true
        },
        meta: {
            icon: "mdi-text-search-variant",
            localize: "fraud.menu.ruleSets",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/aksit/ruleset-mappings",
        name: "AksitRuleSetMappings",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSetMappings.vue"),
        },
        meta: {
            icon: "mdi-format-horizontal-align-center",
            localize: "fraud.menu.ruleSetMappings",
            isEntitySelectionEnabled: true
        },
    },
    {
        path: "/aksit/rulesetresponse",
        name: "AksitRulesetResponse",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/fraud/RuleSetResponse.vue"),
        },
        meta: {
            icon: "mdi-credit-card-refund-outline",
            localize: "fraud.menu.rulesetresponse",
            isEntitySelectionEnabled: true
        }
    },
    {
        path: "/aksit/camera-management",
        name: "AksitCameraManagement",
        component: () => import("../components/fraud/FraudManagementBase.component.vue"),
        props: {
            managementComponent: () => import("../views/aksit/AksitCameraManagement.vue"),
        },
        meta: {
            icon: "mdi-cctv",
            localize: "aksit.menu.cameraManagement"
        },
        perm: constant.PERMISSIONS.aksitCamera
    },
    ...aksitSystemSettingsRoutes,
    ...aksitRestActionRoutes
];

for (const route of routes) {
    route.meta.layout = () => import("../components/layouts/AksitLayout.component.vue");
}

export default routes;
